import { createGridComponent } from '../shared/helpers.ts';
import classes from './Placeholder.module.css';
import { PlaceholderSkeleton } from './PlaceholderSkeleton.tsx';
import { PlaceholderSchema } from './schema.ts';

export const Placeholder = createGridComponent(
  ({ label = 'Placeholder' }) => <div className={classes.placeholder}>{label}</div>,
  PlaceholderSchema,
  PlaceholderSkeleton,
);
